import { useCallback } from 'react';
import { sendNotificationDismissEvent } from '@connect-x-app/hybrid-data-access';

export const useNotificationSocketSendEvents = () => {
  const dismissNotification = useCallback(async (notificationId: string) => {
    return await sendNotificationDismissEvent(notificationId);
  }, []);

  return { dismissNotification };
};
